<template>
  <v-container>
    <material-card>
      <v-layout slot="header" px-3>
        <v-flex my-4 pl-4 title align-center justify-center>{{ title }}</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="ACCOUNT.REGISTER">
            <v-btn large color="error" @click="$emit('add')">DODAJ MIESZKAŃCA</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entity-type="profile"
        :items="users"
        :headers="headers"
        :total-count="count"
        :actions="actions"
        @delete="$emit('delete', $event.id)"
        @details="goToDetails"
      />
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { DELETE_ACTION, DETAILS_ACTION } from '@/utils/actions';
import { UserState } from '@witkac/kartamiejska-shared';

const accountStateTranslation = {
  [UserState.NOT_CONFIRMED]: 'Niepotwierdzone',
  [UserState.DISABLED]: 'Wyłączone',
  [UserState.ACTIVE]: 'Aktywne'
};

/**
 * @vuese
 * @group Officials
 * Lista klientów
 */

export default {
  components: {
    MaterialTable,
    MaterialCard,
    Search
  },
  props: {
    // Tytuł strony
    title: String,
    // Lista klientów
    users: Array,
    // Całkowita liczba klientów
    count: Number
    // Link do szczegółów
  },
  data: () => ({
    headers: [
      { value: 'user.login', sortable: false, text: 'Login', link: true, render: profile => profile.user.login },
      { value: 'email', text: 'Email', orderBy: 'email', link: true },
      { value: 'firstName', text: 'Imię', orderBy: ['firstName', 'lastName', 'id'] },
      { value: 'lastName', text: 'Nazwisko', orderBy: ['lastName', 'firstName', 'id'] },
      {
        value: 'user.state',
        text: 'Status konta',
        sortable: false,
        render: profile => accountStateTranslation[profile.user.state]
      }
    ],
    actions: [DETAILS_ACTION, DELETE_ACTION]
  }),
  methods: {
    goToDetails(profile) {
      this.$router.push({ name: 'client', params: { id: profile.userId } });
    }
  }
};
</script>
